import React from "react";
import { HiOutlineChartBar } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { PlanTier, usePermissions } from "../../utils/permissions";
import useAuth from "../../hooks/useAuth";
import OptionToggleRow from "./OptionToggleRow";

interface StatisticsToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  title?: string;
  description?: string;
}

const StatisticsToggle: React.FC<StatisticsToggleProps> = ({
  enabled,
  onChange,
  title,
  description,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const permissions = usePermissions(user);

  const hasPermission = !permissions.isPlanTier(PlanTier.FREE);

  return (
    <OptionToggleRow
      icon={HiOutlineChartBar}
      iconClassName="text-blue-600"
      title={title ?? t("businessCardPage.optionsTab.statistics.title")}
      description={
        description ?? t("businessCardPage.optionsTab.statistics.subLabel")
      }
      enabled={enabled}
      onChange={(value) => hasPermission && onChange(value)}
      disabled={!hasPermission}
    />
  );
};

export default StatisticsToggle;
